export default {"src":"/_next/static/media/404.149bbcc6.svg","height":290,"width":470,"blurWidth":0,"blurHeight":0};